import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import {
  DEALS_ADD_PATH,
  DEALS_PATH,
  DEALS_UPDATE_PATH,
  EVENT_TICKETS_PATH,
  DEAL_VOUCHERS_PATH,
  DEAL_REDEMPTIONS_PATH,
} from "utils/constants/paths";

const EventTickets = Loadable(React.lazy(() => import("./View/TicketsList")));
const DealVouchers = Loadable(React.lazy(() => import("./View/VouchersList")));
const RedemptionHistory = Loadable(
  React.lazy(() => import("./View/RedemptionHistory"))
);
const Deals = Loadable(React.lazy(() => import("./View")));
const DealsAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const DealsRoute: IRouteItem = {
  path: DEALS_PATH,
  iconName: "DiscountShape",
  element: React.createElement(Deals),
  name: "Deals / Events",
  accessKeys: ["SuperAdmin", "Admin", "ContentManager"],
  children: [
    {
      name: "Add / Update",
      path: DEALS_ADD_PATH,
      element: React.createElement(DealsAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: DEALS_UPDATE_PATH,
      element: React.createElement(DealsAddOrUpdate),
      showInDrawer: false,
    },
    {
      name: "Tickets",
      path: `${EVENT_TICKETS_PATH}/:id`,
      element: React.createElement(EventTickets),
      showInDrawer: false,
    },
    {
      name: "Vouchers",
      path: `${DEAL_VOUCHERS_PATH}/:id`,
      element: React.createElement(DealVouchers),
      showInDrawer: false,
    },
    {
      name: "Redemption History",
      path: `${DEAL_REDEMPTIONS_PATH}/:purchaseId`,
      element: React.createElement(RedemptionHistory),
      showInDrawer: false,
    },
  ],
};
